module.exports = __webpack_public_path__ + "img/gift1.f8866b4c.png";